import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

type SnackSegment =
  | { type: 'text'; text: string }
  | { type: 'link'; label: string; href: string; target?: '_blank' | '_self' | '_parent' | '_top'; rel?: string };

export type SnackWithLinksData = {
  segments: SnackSegment[];
  closeText?: string;
};

@Component({
  selector: 'app-snackbar-with-links',
  imports: [MatButtonModule],
  template: `
    <div class="snack">
      <span>
        @for (seg of data.segments; track seg) {
          @if (isText(seg)) {
            {{ seg.text }}
          }
          @if (isLink(seg)) {
            <a [href]="seg.href" [target]="seg.target || '_self'" [attr.rel]="seg.rel || (seg.target === '_blank' ? 'noopener' : null)">
              {{ seg.label }}
            </a>
          }
        }
      </span>
      <button mat-button class="custom-snack-btn" (click)="snackRef.dismiss()">{{ data.closeText || 'Close' }}</button>
    </div>
  `,
  styles: [
    `
      .snack {
        display: flex;
        align-items: center;
        gap: 0.75rem;
      }

      .snack a {
        color: #1a73e8; /* accessible blue on dark/light backgrounds */
        font-weight: 600;
      }
      .snack a:hover {
        color: #0b57d0; /* darker on hover for better contrast */
      }
      .snack a:focus-visible {
        outline: 2px solid #0b57d0; /* keyboard focus ring */
        outline-offset: 2px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarWithLinksComponent {
  readonly snackRef = inject<MatSnackBarRef<SnackbarWithLinksComponent>>(MatSnackBarRef);
  readonly data = inject<SnackWithLinksData>(MAT_SNACK_BAR_DATA);

  isText(seg: SnackSegment): seg is Extract<SnackSegment, { type: 'text' }> {
    return seg.type === 'text';
  }

  isLink(seg: SnackSegment): seg is Extract<SnackSegment, { type: 'link' }> {
    return seg.type === 'link';
  }
}
